import { createUseStyles } from "react-jss";
import { colors } from "../../../../styles/colors";

const useStyles = createUseStyles({
  containerText: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "10px 0px",
    minWidth: "min(380px, 78vw)",
    width: "100%",
    boxSizing: "border-box",
  },
  errorText: {
    color: "#EF4444",
    fontSize: "11px",
    paddingLeft: "26px",
    marginTop: "-8px",
  },
  logoRow: {
    display: "flex",
    flexDirection: "row",
    gap: "14px",
    alignItems: "center",
  },
  logoPreview: {
    width: "72px",
    height: "72px",
    borderRadius: "10px",
    border: `1px solid ${colors.borderLight}`,
    backgroundColor: colors.surface,
    objectFit: "contain",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    flexShrink: 0,
  },
  logoPreviewImg: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  logoActions: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  hiddenFileInput: {
    display: "none",
  },
});

export default useStyles;
